import { createActionCreator } from "common/ReduxUtils";
import { TransferCreateActionTypes } from "./TransferCreateActionTypes";
import { StorageWarehouseInventory } from "common/clients/storage/StorageWarehouseInventory";

export const setAvailableInventoryInEachStorageWarehouse = createActionCreator<StorageWarehouseInventory[]>(
  TransferCreateActionTypes.TRANSFER_SET_AVAILABLE_INVENTORY,
  "availableInventory"
);
